module.exports = __webpack_public_path__ + "static/media/inhousenews_img.3ac4b6d7.png";